import { useEffect, useMemo, useState } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetWH/Main";
import Form from "./TbSetWH/Form";

// Utils
import { getAlert, getDataByQuery, getDataWithComp } from "../../../utils/SamuiUtils";

const TbSetWh = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState({});
  const [activeAfterSaveId, setActiveAfterSaveId] = useState(null);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async (editedId) => {
    try {
      if (editedId != null) {
        setActiveAfterSaveId(editedId);
        await fetchRealtime();
      }
      setMode("S");
      setSelectedData(null);
      setFormData({});
      if (editedId == null) await fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message || "ไม่สามารถโหลดข้อมูลได้");
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "Tb_Set_WH",
        "ORDER BY WH_Code"
      );
      if (Array.isArray(masterList)) {
        setDataMasterList(masterList);
      } else {
        setDataMasterList([]);
      }
    } catch (error) {
      getAlert("FAILED", error.message || "ไม่สามารถโหลดข้อมูลได้");
    }
  };

  const hasCompIdField = useMemo(() => {
    if (!Array.isArray(dataMasterList) || dataMasterList.length === 0) {
      return false;
    }
    return dataMasterList.some((item) =>
      Object.prototype.hasOwnProperty.call(item || {}, "Comp_Id")
    );
  }, [dataMasterList]);

  const fetchNextWHCode = async () => {
    try {
      const companyId = localStorage.getItem("company") || "";
      const query = `
        SELECT COALESCE(MAX(TRY_CAST(WH_Code AS INT)), 0) AS Max_WH_Code
        FROM Tb_Set_WH
        WHERE Comp_Id = '${companyId}'
          AND ISNULL(WH_Code, '') <> '999'
      `.trim();

      const response = await getDataByQuery(query);

      if (Array.isArray(response) && response.length > 0) {
        const maxCode = Number(response[0]?.Max_WH_Code) || 0;
        return String(maxCode + 1);
      }
    } catch (error) {
      console.error("Failed to fetch next WH code:", error);
    }
    return "1";
  };

  const onPageInsert = async () => {
    setSelectedData(null);
    const nextCode = await fetchNextWHCode();
    setFormData({
      WH_Code: nextCode,
      WH_Name: "",
      WH_Status: "Y",
      ...(hasCompIdField
        ? { Comp_Id: localStorage.getItem("company") || undefined }
        : {}),
    });
    setMode("I");
  };

  const onRowSelected = (itemOrId) => {
    const item =
      typeof itemOrId === "number"
        ? dataMasterList.find((data) => data.WH_Id === itemOrId)
        : itemOrId;

    if (!item) {
      getAlert("WARNING", "ไม่พบข้อมูลคลังที่เลือก");
      return;
    }

    setMode("U");
    setFormData({
      WH_Id: item.WH_Id,
      WH_Code: item.WH_Code,
      WH_Name: item.WH_Name,
      WH_Status: item.WH_Status,
      ...(hasCompIdField ? { Comp_Id: item.Comp_Id } : {}),
    });
    setSelectedData(item);
  };

  return (
    <div className="TbSetWH">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <div style={{ display: mode === "S" ? "block" : "none" }}>
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลคลังสินค้า"}
                  onPageInsert={onPageInsert}
                  onRowSelected={onRowSelected}
                  activeAfterSaveId={activeAfterSaveId}
                  onClearActiveAfterSave={() => setActiveAfterSaveId(null)}
                  idField="WH_Id"
                />
              </div>
              <div style={{ display: mode !== "S" ? "block" : "none" }}>
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลคลังสินค้า"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  masterList={dataMasterList}
                  setMode={setMode}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetWh;
